export class MdhlSetting {
    settingId: number;
    registartionCharges: number;
    laminatedHealthCard: number;
    plasticLaminatedHelathCard: number;
}
